<template lang="pug">
  .height-100
    h3.title Gestión de vacaciones de mi equipo
    p

    transition-group.contenedor-box(name="fade-smooth-two", tag="div")
      .box.position-relative(v-if="mostrarListaSolicitudesPorAprobar", key="lista_solicitud_por_aprobar")
        lista-solicitud-vacaciones-por-aprobar(
          @close="mostrarListaSolicitudesPorAprobar = false"
        )
      .box.position-relative(v-if="mostrarListaEquipoVacaciones", key="lista_vacaciones_equipo")
        lista-equipo-vacaciones(
          @close="mostrarListaEquipoVacaciones = false"
        )

</template>

<script>
import ListaSolicitudVacacionesPorAprobarComponent from './Component_Lista_Solicitud_Vacaciones_Por_Aprobar'
import ListaEquipoVacacionesComponent from './Component_Lista_Equipo_Vacaciones'
export default {
  name: 'vacaciones-equipo',
  components: {
    'lista-solicitud-vacaciones-por-aprobar': ListaSolicitudVacacionesPorAprobarComponent,
    'lista-equipo-vacaciones': ListaEquipoVacacionesComponent
  },
  data () {
    return {
      mostrarListaSolicitudesPorAprobar: true,
      mostrarListaEquipoVacaciones: true
    }
  },
  watch : {
  },
  created () {
  },
  methods: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>
  .contenedor-box
    display flex
    justify-content center
    flex-direction column
    position relative
    >*
      transition all .5s
      width 100%
</style>



// WEBPACK FOOTER //
// View_Vacaciones_Equipo.vue?351bc3ee